import axios, {AxiosRequestConfig} from 'axios'

class ApiClient {

  protected config: AxiosRequestConfig;
  protected errorHandler?: (reason: any) => void;

  constructor(baseUrl: string, errorHandler?: (reason: any) => void) {
    this.config = {
      baseURL: baseUrl
    };
    this.errorHandler = errorHandler;
  }

  public setAuthorization(token?: string) {
    if (this.config.headers == null) {
      this.config.headers = {};
    }
    if (token == null && Object.prototype.hasOwnProperty.call(this.config.headers, 'Authorization')) {
      delete this.config.headers.Authorization;
    } else {
      this.config.headers.Authorization = token;
    }
  }

  public get(endpoint: string) {
    return axios.get(endpoint, this.config);
  }

  public post(endpoint: string, data: object) {
    return axios.post(endpoint, data, this.config);
  }

  public put(endpoint: string, data: object) {
    return axios.put(endpoint, data, this.config);
  }

  public patch(endpoint: string, data: object) {
    return axios.patch(endpoint, data, this.config);
  }

  public delete(endpoint: string) {
    return axios.delete(endpoint, this.config);
  }

  private onError(reason: any) {
    if (this.errorHandler != null) {
      this.errorHandler(reason);
    }
  }
}

export default ApiClient;
